import { RequirementsComplianceScore } from '@abb-procure/data';
import { BooleanInput } from '@angular/cdk/coercion';
import { booleanAttribute, Component, computed, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'procure-compliance-graph',
  templateUrl: './compliance-graph.component.html',
  styleUrl: './compliance-graph.component.scss',
  imports: [MatTooltip],
})
export class ComplianceGraph {
  readonly scores = input<RequirementsComplianceScore | null>(null);

  readonly standalone = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly fulfilledCount = computed(() => this.scores()?.fulfilledCount ?? 0);

  readonly forClarificationCount = computed(
    () => this.scores()?.forClarificationCount ?? 0,
  );

  readonly unselectedCount = computed(
    () => this.scores()?.unselectedCount ?? 0,
  );

  readonly totalCount = computed(() => this.scores()?.totalCount ?? 0);
}
